const {
    login_url: loginUrl,
    authorize_url: authorizeUrl,
    business_api_url: businessUrl,
    market_rates_insights_api_url: marketRateInsightsUrl,
    truck_load_rate_api_url: truckLoadRateUrl,
    network_api_url: networkUrl,
    payment_url: paymentUrl,
    base_api_url: baseApiUrl,
    tlr_subscription_modify: tlrSubscriptionModify
} = (window as any).tcx_transportationinsights_configs;

export default {
    authorityUrl: `https://${baseApiUrl}${authorizeUrl}/v2`,
    issuer: authorizeUrl,
    authorizationUrl: `https://${baseApiUrl}${authorizeUrl}/authorize`,
    tokenUrl: `https://${baseApiUrl}${authorizeUrl}/token?tenantDomain=trimble.com`,
    userinfoUrl: `https://${baseApiUrl}${authorizeUrl}/userinfo-v2?schema=openid`,
    jwksUrl: `https://${baseApiUrl}${authorizeUrl}/v1.1/.well-known/jwks.json`,
    LogoutUri: `https://${baseApiUrl}${authorizeUrl}/i/commonauth?commonAuthLogout=true&type=samlsso&sessionDataKey=E294FEF4A64BF7E14940E2964F78E351&commonAuthCallerPath=${loginUrl}`,
    redirectUrl: `https://${baseApiUrl}${loginUrl}/authorize`,
    endSessionUrl: `https://${baseApiUrl}${loginUrl}/revoke`,
    marketInsightsAuthorizationStatus: `https://${baseApiUrl}${marketRateInsightsUrl}/marketRates/authStatus`,
    locationSearch: `https://${baseApiUrl}${businessUrl}/Locations`,
    laneDetails: `https://${baseApiUrl}${businessUrl}/MarketRates/LaneDetails`,
    seasonality: `https://${baseApiUrl}${businessUrl}/MarketRates/Seasonality`,
    rankingArea2area: `https://${baseApiUrl}${marketRateInsightsUrl}/marketRates/ranking/area2area/`,
    rankingArea2areaInboundAndOutbound: `https://${baseApiUrl}${marketRateInsightsUrl}/marketRates/ranking/area2area/inboundAndOutbound/`,
    truckLoadRateAuthorizationStatus: `https://${baseApiUrl}${truckLoadRateUrl}/authStatus`,
    truckLoadRateAdminAuthorizationStatus: `https://${baseApiUrl}${truckLoadRateUrl}/admin/authStatus`,
    allSavedLanes: `https://${baseApiUrl}${truckLoadRateUrl}/allSavedLanes/`,
    saveSearchedLane: `https://${baseApiUrl}${truckLoadRateUrl}/saveSearchedLane/`,
    deleteSavedLane: `https://${baseApiUrl}${truckLoadRateUrl}/lanes/`,
    chartsNationalHaul: `https://${baseApiUrl}${marketRateInsightsUrl}/marketRates/charts/national/haul`,
    chartsStateRate: `https://${baseApiUrl}${marketRateInsightsUrl}/marketRates/charts/state/rate`,
    downloadRateProcessTemplate: `https://${baseApiUrl}${truckLoadRateUrl}/rate-manager/download/batchUploadTemplate`,
    verifyProcessRates: `https://${baseApiUrl}${truckLoadRateUrl}/rate-manager/validateRatesFile`,
    submitProcessRates: `https://${baseApiUrl}${truckLoadRateUrl}/rate-manager/upload`,
    getProcessRateHistory: `https://${baseApiUrl}${truckLoadRateUrl}/rate-manager/files`,
    downloadProcessedRates: `https://${baseApiUrl}${truckLoadRateUrl}/rate-manager/download/outputFile`,
    networkAuthorizationStatus: `https://${baseApiUrl}${networkUrl}/authStatus`,
    networkLanes: `https://${baseApiUrl}${networkUrl}/lanes`,
    networkLanesKeyPerformanceIndicators: `https://${baseApiUrl}${networkUrl}/lanes/kpi`,
    geographyPolygons: `https://${baseApiUrl}${networkUrl}/geography/area/geojson`,
    getTCXUsers: `https://${baseApiUrl}${truckLoadRateUrl}/admin/users`,
    createTCXUsers: `https://${baseApiUrl}${truckLoadRateUrl}/admin/users/create`,
    deleteTCXUser: `https://${baseApiUrl}${truckLoadRateUrl}/admin/users`,
    updateTCXUsers: `https://${baseApiUrl}${truckLoadRateUrl}/admin/users`,
    ttcUserInfo: `https://${baseApiUrl}/api/identity/v2/oauth2/userinfo`,
    ttcActivityEndPoint: `https://${baseApiUrl}/iam/v2/users/activity`,
    getBillingHistory: `https://${baseApiUrl}${paymentUrl}/billingHistory`,
    downloadInvoice: `https://${baseApiUrl}${paymentUrl}/billingHistory/download`,
    tlrSubscriptionModify: `${tlrSubscriptionModify}`,
    tlrSubscriptionStatusEndPoint: `https://${baseApiUrl}${truckLoadRateUrl}/admin/subscription/status`
};
